import * as actionTypes from "../actionTypes";

const initialState = {
  ingredient_details: null,
  is_redirect_menu_ingredient: false,
  ingreMeasureUnitModal: false,
  check_supplier_details: 0,
  storageAreaModalModal: false,
  backupIngredientModal: false,
  backupIngredientModal_loading: false,
  is_add_storage_loading: false,
  add_storage_new_id: "",
  ingredient_conversion_details: null,
  inventory_uom_details: null,
  backup_ingredient_list: [],
  recipe_details: null,
  ingreRecipeModal: false,
  measurement_unit_details: null,
  is_redirect_menu_recipe: false,
  menu_item_details: null,
  updateItemClassModal: false,
  item_subclass_detail: null,
  updateItemCategoryModal: false,
  item_subcategory_detail: null,
  reload_list_flag: null,
  updateItemStatusModal: false,
  updateItemLifespanModal: false,
  item_lifespan_details: null,

  // menu pricing
  menuPricingDetails: null,
  menuScheduledPricingDetails: null,
  menu_new_pricing_modal_state: false,
  add_item_details: null,
  menuSearchResult: null,
  menuItemSalesType: null,
  editScheduleMenuItem: null,

  componentItemModal: false,
  item_ca_details: null,
  serviceItemModal: false,
  add_pricings_details: null,
  priceItemModal: false,
  saved_pricings_details: [],
  edit_pricings_details: null,
  bundledOptionsModal: false,
  menu_item_list: [],
  cost_per_item: [],
  is_redirect_flag: false,
  // Custom Modifier
  modifierItemModal: false,
  item_modifiers_details: null,
  copyModifierModal: false,
  copy_modifier_details: null,
  edit_modifier_details: null,
};

const menuReducer = (state = initialState, action) => {
  const { type, payload = {}, valType } = action;

  switch (type) {
    case actionTypes.SET_MODAL_STATE: {
      return { ...state, [payload.modalName]: payload.modalState };
    }

    case actionTypes.MENU_VALUE_CHANGE:
      return {
        ...state,
        [valType]: payload,
      };
    case actionTypes.MENU_INITIAL_VALUE:
      return initialState;

    case actionTypes.SAVE_MENU_PRICING_DETAILS: {
      return {
        ...state,
        menuPricingDetails: payload,
      };
    }
    case actionTypes.SAVE_SCHEDULED_MENU_PRICING_DETAILS: {
      return {
        ...state,
        menuScheduledPricingDetails: payload,
      };
    }
    case actionTypes.SAVE_SEARCH_MENU_RESULT: {
      return {
        ...state,
        menuSearchResult: payload,
      };
    }
    case actionTypes.SAVE_SALES_TYPE: {
      return {
        ...state,
        menuItemSalesType: payload,
      };
    }
    case actionTypes.SAVE_EDIT_SCHEDULED_MENU_ITEM: {
      return {
        ...state,
        editScheduleMenuItem: payload,
      };
    }
    default:
      return state;
  }
};
export default menuReducer;
